export const DtiFormInputBase = {
  incomeFormTitle: 'What is your monthly gross income?',
  minIncomeValue: 0,
  maxIncomeValue: 50000,
  debtFormTitle: 'What is your monthly debt & expense?',
  minDebtValue: 0,
  maxDebtValue: 50000,
  creditCardTitle: 'What is your credit card balance (est.)?',
  minCreditValue: 0,
  maxCreditValue: 150000,
  onChangeIncome: () => {},
  onChangeExpenses: () => {},
  onChangeCredit: () => {},
  enableSubmit: () => {},
  'data-testid': 'dti-form-inputs-container',
}
